class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', (event) => {
      this.expandShowMore(event, button);
      const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item')
      // if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
      //   nextElementToFocus.querySelector('input').focus()
      // }
    });
  }
  expandShowMore(event, button) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
    const parentWrap = parentDisplay.querySelector('.parent-wrap');
    // this.querySelectorAll('.label-text').forEach(element => element.classList.toggle('hidden'));
    var items = parentDisplay.querySelectorAll('.show-more-item.only-mobile');
    if (items.length <= 6) {
      button.classList.add('hidden');
    }
    for (let i = 0; i < 6; i++) {
      if (i >= items.length) {
        continue;
      }
      items[i].classList.remove('only-mobile');
      console.log(items[i].classList)
    }
    
    // .forEach(item => item.classList.toggle('only-mobile'))
  }
}

customElements.define('load-more-button', LoadMoreButton);